<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20">
    <g transform="translate(-22 -455)">
      <g transform="translate(-1 2)">
        <path class="a" d="M15,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H15" transform="translate(21 451)"/>
        <g transform="translate(-687 343.621)">
          <path class="a" d="M11.673,3.278A1.363,1.363,0,1,1,13.6,5.205L5.57,13.236,3,13.879l.642-2.57Z"
                transform="translate(716 109.621)"/>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'InIcon'
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
